import { MIN_DESKTOP_WIDTH } from '~~/constants/ui';

/**
 * A composable that helps to define the size of the window
 * Should be avoided on template as it creates render errors at non-mobile devices at small widths
 */
// Only use this composable where css solution won't give expected results
export const useUiMode = () => {

  const width = ref(import.meta.client ? window.innerWidth : MIN_DESKTOP_WIDTH);

  const updateWidth = () => {

    if (!import.meta.client) {

      return;
    
    }
    width.value = window.innerWidth;
  
  };

  onMounted(() => {

    if (!import.meta.client) {

      return;
    
    }
    updateWidth();
    window.addEventListener('resize', updateWidth);
  
  });

  onUnmounted(() => {

    if (!import.meta.client) {

      return;
    
    }
    window.removeEventListener('resize', updateWidth);
  
  });

  const isMobile = computed(() => width.value < MIN_DESKTOP_WIDTH);

  return {
    isMobile,
  };

};
